import React, { useMemo } from 'react';
import {
    CartesianGrid,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';
import { useTheme } from 'styled-components';
import { ChartWrap } from './styles';

function formatAxisDate(iso) {
    if (!iso) return '';
    const [, month, day] = iso.split('-');
    return `${day}/${month}`;
}

/**
 * @param {{ points?: Array<{ date: string, value: number }>, loading?: boolean }} props
 */
export default function TimeSeriesChart({ points = [], loading = false }) {
    const theme = useTheme();
    const stroke = theme?.colors?.primary?.main || '#3B5998';

    const chartData = useMemo(
        () =>
            (points || []).map((p) => ({
                ...p,
                label: formatAxisDate(p.date),
            })),
        [points],
    );

    if (!loading && chartData.length === 0) {
        return null;
    }

    return (
        <ChartWrap $minHeight="240px" aria-busy={loading || undefined}>
            <ResponsiveContainer width="100%" height={240}>
                <LineChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke={theme?.colors?.gray?.[200] || '#e5e7eb'} />
                    <XAxis
                        dataKey="label"
                        tick={{ fontSize: 11, fill: theme?.colors?.gray?.[600] || '#718096' }}
                        interval="preserveStartEnd"
                    />
                    <YAxis
                        allowDecimals={false}
                        tick={{ fontSize: 11, fill: theme?.colors?.gray?.[600] || '#718096' }}
                        width={40}
                    />
                    <Tooltip
                        formatter={(value) => [Number(value).toLocaleString('pt-BR'), 'Entregas']}
                        labelFormatter={(_, payload) => payload?.[0]?.payload?.date || ''}
                    />
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke={stroke}
                        strokeWidth={2}
                        dot={chartData.length <= 31 ? { r: 3 } : false}
                        activeDot={{ r: 5 }}
                        isAnimationActive={!loading}
                    />
                </LineChart>
            </ResponsiveContainer>
        </ChartWrap>
    );
}
